import React, { useState } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import Image from 'react-bootstrap/Image';
import { useNavigate } from 'react-router-dom'; // Usa useNavigate para la navegación en react-router-dom v6
import { fetchGetData } from '../dataVar/apiService';
import 'bootstrap/dist/css/bootstrap.min.css'; // Asegúrate de importar Bootstrap CSS
import '../Utils/styles.css'; // Importa los estilos globales si es necesario
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
// Cache-bust de las imágenes de fondo (una vez por carga de página, mismo patrón que Login.js)
const CACHE_BUST = Date.now();


const OlvidoPassword = () => {
    const [error, setError] = useState("");
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [celular, setCelular] = useState('');
    const [enviarA, setEnviarA] = useState(''); // Nuevo estado para enviarA
    const navigate = useNavigate();

    // Estados para manejar errores individuales
    const [usernameError, setUsernameError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [celularError, setCelularError] = useState("");
    const [captchaError, setCaptchaRError] = useState("");
    const [enviarAError, setEnviarAError] = useState(""); // Nuevo estado de error

    const usernameRegex = /^[1-9][0-9]{5,13}$/;
    const emailRegex = /^[a-zA-Z0-9_.+-]{1,64}@[a-zA-Z0-9-]{1,63}\.[a-zA-Z]{2,6}$/;

    const handleValidaLogin = async () => {
        // Reiniciar errores
        setUsernameError("");
        setEmailError("");
        setCelularError("");
        setCaptchaRError("");
        setEnviarAError("");

        let hasError = false;

        if (!username) {
            setUsernameError("Usuario no válido.");
            hasError = true;
        }

        if (!email) {
            setEmailError("Por favor ingrese email");
            hasError = true;
        }

        if (!celular) {
            setCelularError("Por favor ingrese celular.");
            hasError = true;
        }

        if (!usernameRegex.test(username)) {
            setUsernameError("Usuario no válido.");
            hasError = true;
        }

        if (!emailRegex.test(email)) {
            setEmailError("Email no válido.");
            hasError = true;
        }

        // Validar enviarA
        if (!enviarA) {
            setEnviarAError("Por favor seleccione dónde desea recibir la nueva contraseña.");
            hasError = true;
        }

         // Validar CAPTCHA - TEMPORALMENTE DESACTIVADO
        /*
        if (!captchaVerified) {
            setCaptchaRError("Por favor, completa el CAPTCHA.");
            hasError = true;
        }
        */

        // Si hay errores, detener la ejecución
        if (hasError) {
            return;
        }

        try {
            setError("");
            const OlvidoArray = await fetchGetData('api/Usuario/OlvidoPassword', `${username}/${email}/${celular}/${enviarA}`);
            if (Array.isArray(OlvidoArray) && OlvidoArray.length > 0) {
                const Olvido = OlvidoArray[0];

                if (Olvido.hasOwnProperty('Error')) {
                    const error = Olvido.Error;
                    if (error === "OK") {
                        alert("Contraseña Cambiada Exitosamente, se envió a donde lo solicitaste");
                        navigate("/Login");
                    } else {
                        alert("Error: " + error);
                        setError(error);
                    }
                } else {
                    setError("Respuesta inesperada del servidor.");
                }
            } else {
                alert("Los datos enviados no existen en la BD");
            }
        } catch (error) {
            setError(`Error al procesar la solicitud: ${error.message || error}`);
        }
    };

    const LogoXUECia = '/imagenes/LogoXUECia.png';
    // ?v= por carga de página: el fondo se cambia desde Identidad Corporativa y no debe quedar en caché
    const fondo = `/imagenes/Fondo_i.png?v=${CACHE_BUST}`;

    return (
        <Container fluid style={{ height: '100vh' }}>
            <Row style={{ height: '100%' }}>
                <Col sm={6} className='d-none d-sm-block px-0' style={{ height: '100%' }}>
                    <Image
                        src={fondo}
                        alt="Login image"
                        fluid
                        className="w-100"
                        style={{
                            objectFit: 'fill',
                            width: '100%',
                            height: '100%'
                        }}
                    />
                </Col>

                <Col xs={12} sm={6} style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div className="col-lg-7 p-4" style={{ backgroundColor: 'rgba(255, 255, 255, 0.56)', borderRadius: '20px' }}>
                        
                        
                        <Form onSubmit={(e) => { e.preventDefault(); handleValidaLogin(); }}>
                            <Row>
                                <h3>Restaurar Contraseña</h3>
                            </Row>

                            <div className="p-inputgroup">
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-user"></i>
                                </span>
                                <InputText
                                    value={username}
                                    type="number"
                                    onChange={(e) => setUsername(e.target.value)}
                                    placeholder="Ingrese su usuario"
                                    className={usernameError ? 'p-invalid' : ''}
                                />
                            </div>
                            {usernameError && <small className="p-error">{usernameError}</small>}

                            <div className="p-inputgroup mt-3">
                                <div className="p-inputgroup">
                                    <span className="p-inputgroup-addon">
                                        <i className="pi pi-inbox"></i>
                                    </span>
                                    <InputText
                                        value={email}
                                        type="email"
                                        placeholder="eMail Registrado"
                                        onChange={(e) => {
                                            setEmail(e.target.value);
                                        }}
                                        className={error && !emailRegex.test(email) ? 'p-invalid' : ''}
                                    />
                                </div>
                            </div>
                            {emailError && <small className="p-error">{emailError}</small>}

                            <div className="p-inputgroup mt-3">
                                <div className="p-inputgroup">
                                    <span className="p-inputgroup-addon">
                                        <i className="pi pi-calculator"></i>
                                    </span>
                                    <InputText
                                        value={celular}
                                        type="number"
                                        placeholder="Celular Registrado"
                                        onChange={(e) => setCelular(e.target.value)}
                                    />
                                </div>
                            </div>
                            {celularError && <small className="p-error">{celularError}</small>}

                            {/* Selector para envío de contraseña */}
                            <div className="mt-3">
                                <label className="form-label">¿Dónde desea recibir su nueva contraseña?</label>
                                <div className="d-flex flex-column gap-2">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="enviarA"
                                            id="enviarEmail"
                                            value="EMAIL"
                                            checked={enviarA === 'EMAIL'}
                                            onChange={(e) => setEnviarA(e.target.value)}
                                        />
                                        <label className="form-check-label" htmlFor="enviarEmail">
                                            <i className="pi pi-envelope me-2"></i>
                                            Enviar al correo electrónico
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="enviarA"
                                            id="enviarSMS"
                                            value="SMS"
                                            checked={enviarA === 'SMS'}
                                            onChange={(e) => setEnviarA(e.target.value)}
                                        />
                                        <label className="form-check-label" htmlFor="enviarSMS">
                                            <i className="pi pi-mobile me-2"></i>
                                            Enviar por SMS al celular
                                        </label>
                                    </div>
                                </div>
                            </div>
                            {enviarAError && <small className="p-error d-block mt-1">{enviarAError}</small>}

{/* CAPTCHA - TEMPORALMENTE DESACTIVADO */}
                                    {/* 
                                    <div className="d-flex justify-content-center mt-3">
                                        <ReCAPTCHA
                                            sitekey={siteKey}
                                            onChange={handleCaptcha}
                                        />
                                    </div>
                                    {captchaError && <small className="p-error">{captchaError}</small>}
                                    */}


                            {/* Botón de inicio de sesión */}
                            <div className="d-flex justify-content-center mt-3">
                                <Button label="Restaurar" icon="pi pi-sync" type="submit" className="p-button-primary w-full" />
                            </div>

                            {/* Enlace para volver al login */}
                            <div className="d-flex justify-content-center mt-3">
                                <Button
                                    label="Volver al Login"
                                    className="p-button-text mt-2"
                                    onClick={() => navigate('/login')}
                                />
                            </div>

                            <div className="text-center mb-3 mt-2">  {/* mb-3 abajo, mt-5 arriba */}
                                <Image src={LogoXUECia} width={100} alt="LogoXUECia" />
                            </div>

                        </Form>



                    </div>
                </Col >
            </Row >
        </Container >
    );

};

export default OlvidoPassword;
